import { ArrowLeft, Shield } from "lucide-react";
import { INSTANCE } from "../lib/instance";
import { brandTitle } from "../../../shared/instance";
import { Eyebrow } from "../components/brand";

export function DatenschutzPage() {
  return (
    <div className="min-h-screen" style={{ background: "var(--color-bg)" }}>
      <div className="max-w-3xl mx-auto py-16 px-6 animate-in">
        <a
          href="#/hub"
          className="inline-flex items-center gap-2 text-sm transition-colors mb-10 no-underline"
          style={{ color: "var(--color-muted)", fontFamily: "var(--font-mono)", fontSize: "0.72rem", textTransform: "uppercase", letterSpacing: "0.18em" }}
        >
          <ArrowLeft size={14} strokeWidth={1.5} /> Zurueck zum Hub
        </a>

        <div className="mb-10">
          <Eyebrow>DSGVO · {brandTitle(INSTANCE)} Hub</Eyebrow>
          <div className="mt-5 flex items-center gap-4">
            <div
              className="w-11 h-11 flex items-center justify-center"
              style={{
                border: "1px solid var(--color-brand-grey-mid, #C6C6C6)",
                borderRadius: "var(--radius-sm)",
                color: "var(--color-brand-blue)",
              }}
            >
              <Shield size={20} strokeWidth={1.5} />
            </div>
            <div>
              <h1
                className="text-2xl font-bold"
                style={{ fontFamily: "var(--font-display)", color: "var(--color-foreground)" }}
              >
                Datenschutzerklaerung
              </h1>
              <p
                className="text-xs mt-1"
                style={{ color: "var(--color-muted)", fontFamily: "var(--font-mono)", letterSpacing: "0.1em", textTransform: "uppercase" }}
              >
                Stand April 2026
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4">
          {[
            { title: "1. Verantwortlicher", content: `${INSTANCE.privacyController}. Kontakt: ${INSTANCE.privacyContactEmail}` },
            { title: "2. Datenverarbeitung", content: "Diese Anwendung verarbeitet personenbezogene Daten (Name, Email, Login-Daten) zum Zweck der Mitarbeiterverwaltung und Projektsteuerung. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfuellung) und Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse)." },
            { title: "3. Hosting", content: "Die Anwendung wird auf Railway (EU-Region Frankfurt) gehostet. Datenbank: PostgreSQL in der EU. Kein Transfer in Drittlaender." },
            { title: "4. Betroffenenrechte", content: `Auskunft (Art. 15), Berichtigung (Art. 16), Loeschung (Art. 17), Einschraenkung (Art. 18), Datenportabilitaet (Art. 20), Widerspruch (Art. 21). Anfragen an ${INSTANCE.privacyContactEmail}.` },
            { title: "5. Protokollierung", content: "Alle Zugriffe und Aenderungen werden in einem Audit-Log protokolliert (Art. 5 Abs. 2 DSGVO — Rechenschaftspflicht). Das Log ist nur fuer Administratoren einsehbar und kann als CSV exportiert werden." },
          ].map(section => (
            <section key={section.title} className="card p-6">
              <h2
                className="text-base font-semibold mb-2"
                style={{ fontFamily: "var(--font-display)", color: "var(--color-foreground)" }}
              >
                {section.title}
              </h2>
              <p
                className="text-sm leading-relaxed"
                style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-body)" }}
              >
                {section.content}
              </p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
